import { Record, List } from 'immutable';

export default class AgreementRecord extends Record({
  id: undefined,
  agreementNumber: undefined,
  bookkeepingAccount: undefined,
  conditions: new List(), // TODO: Double check that this change doesnt have adverse effects.
  createdAt: undefined,
  createdBy: undefined,
  customer: undefined,
  customerAttestNotificationDay1: undefined,
  customerAttestNotificationDay2: undefined,
  customerAttestNotificationDay3: undefined,
  customerAttestNotificationDay4: undefined,
  customerAttestNotificationDay5: undefined,
  customerAttestNotificationDay6: undefined,
  customerAttestNotificationDay7: undefined,
  expiresAt: undefined,
  externalReference: undefined,
  invoicingPeriod: undefined,
  files: new List(),
  holidayPayRate: undefined,
  invoiceSettings: undefined,
  links: new List(),
  mileageAllowanceCustomerUnitPrice: undefined,
  name: undefined,
  replacementModels: undefined,
  resource: undefined,
  staffingCompany: undefined,
  validFrom: undefined,
  workTypes: new List(),
}) {
}
